import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiFileText, FiCalendar } from 'react-icons/fi';

const ddItem = 'block w-full text-left px-4 py-2.5 text-sm text-[#1A1A2E] hover:bg-[#F57C20]/5 transition-colors';

// Split CTA: primary action + hover dropdown offering the other one.
export const HeaderSplitCta = ({ quoteFirst, onQuote }) => {
  const primaryCls = 'whitespace-nowrap inline-flex items-center gap-2 bg-[#F57C20] text-white pl-5 pr-3 py-2.5 text-sm font-semibold tracking-wide rounded-l hover:bg-[#E06A10] transition-colors';
  const quoteItem = (
    <button type="button" data-testid="header-dd-get-quote" onClick={onQuote} className={ddItem}>
      <span className="font-semibold block">Get Off-Site Quote</span>
      <span className="text-[11px] text-[#6B7280]">Instant PDF with live rates</span>
    </button>
  );
  const bookItem = (
    <Link to="/villas" data-testid="header-dd-book-now" className={ddItem}>
      <span className="font-semibold block">Book Now</span>
      <span className="text-[11px] text-[#6B7280]">Pick a villa &amp; pay online</span>
    </Link>
  );
  return (
    <div data-testid="header-split-cta" className="relative group hidden md:flex">
      {quoteFirst ? (
        <button type="button" data-testid="header-get-quote-btn" onClick={onQuote} className={primaryCls}>
          <FiFileText className="w-4 h-4" /> Get Off-Site Quote
        </button>
      ) : (
        <Link to="/villas" data-testid="header-book-now" className={primaryCls}>
          <FiCalendar className="w-4 h-4" /> Book Now
        </Link>
      )}
      <span data-testid="header-split-cta-toggle" className="inline-flex items-center bg-[#E06A10] text-white px-2 rounded-r border-l border-white/30 cursor-pointer">
        <FiChevronDown className="w-4 h-4 transition-transform duration-200 group-hover:rotate-180" />
      </span>
      <div className="absolute right-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-opacity duration-200 z-50">
        <div className="bg-white border border-gray-100 rounded-xl shadow-xl shadow-black/10 py-2 w-56">
          {quoteFirst ? <>{quoteItem}{bookItem}</> : <>{bookItem}{quoteItem}</>}
        </div>
      </div>
    </div>
  );
};

export default HeaderSplitCta;
